export default "__VITE_ASSET__C61cQAMX__"